import { getLocale } from "../runtime";

const sv_ltcountry = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Litauen`
};

const ltcountry = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_ltcountry(inputs)
	return "ltCountry";
};

export { ltcountry as "ltCountry" };